import ExtendableError from './ExtendableError.js';
/** Thrown if the recursion limit is exceeded */
export default class AuthenticationError extends ExtendableError {
    constructor(e, message = 'Unable to authenticate user or session') {
        super(message + '\n' + e.message);
    }
}
